

























import {Component, Vue, Watch} from 'vue-property-decorator';

import {Elastic, TimelineMax} from '@/utils/gsap';

import Icon from '@/components/ui/Icon.vue';

@Component({})
export default class Preloader extends Vue {
	enterTL: any = undefined;
	afterEnterTL: any = undefined;

	progress: { value: number } = {
		value: 0
	};

	isLoaded: boolean = false;
	icons: number = 0;

	$refs: {
		logo: HTMLElement
		progress: HTMLElement
	};

	@Watch('isLoaded')
	onStateChanged(isLoaded: boolean): void {
		this.$root.$emit('isLoaded', isLoaded);
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
		this.createAnimation();

		// - start progress number animation
		// - add class 'is-loaded' on end + debounce of 1s
		// (fyi: svg is animated in css)
		this.initAnimation();
	}

	createAnimation(): void {
		// animate loading progress value
		// "0 %" => "100 %"
		this.enterTL = new TimelineMax({paused: true});

		this.enterTL
			.to(this.progress, 1.4, {
				value: 100
			}, 0.6)
			.to(this.$refs.progress, 0.2, {
				alpha: 0
			})
			.add(() => {
				this.createAfterAnimation();

				this.afterEnterTL
					.seek(0.001)
					.play();
			}, 1.9);
	}

	createAfterAnimation(): void {
		this.afterEnterTL = new TimelineMax({paused: true});

		const logo = this.$refs.logo;

		if (!logo) {
			return;
		}

		const {x, y} = logo.getBoundingClientRect();
		// todo: this problem here
		const {top, left, width} = document.querySelector('.content-section__icon.icon')!.getBoundingClientRect();

		this.afterEnterTL
			.set(logo, {
				position: 'fixed',
				top: y,
				left: x - 30,
				right: 'auto',
				transformOrigin: '0% 0%'
			})
			.to(logo, 0.6, {
				left: left - 30,
				top,
				width,
				alpha: 0.1,
				ease: Elastic.easeOut.config(1, 1)
			}, '+=0.4')
			.add(() => {
				this.isLoaded = true;
			}, '-=0.2');
	}

	initAnimation(): void {
		this.enterTL
			.seek(0.001)
			.play();
	}

	iconLoaded(): void {
		if (typeof window === 'undefined') {
			return;
		}

		setTimeout(() => {
			this.icons++;
		}, 200);
	}
}
